import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { useEffect } from 'react';

export interface useSendActivityLogMessageMutationArguments {
  axios: AxiosInstance;
  id: string;
  text: any;
  resourceKey: string;
}

async function create({ axios, id, text, resourceKey }: useSendActivityLogMessageMutationArguments): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/comments`, {
    ...text,
    subject_type: resourceKey?.replace('_', '-'),
    subject_id: id,
  });
  return data;
}

export default function useSendActivityLogMessageMutation(reset: any, setError: any, queryKey: QueryKey) {
  const queryClient = useQueryClient();
  const axios = useAxios();

  const mutation = useMutation({
    mutationFn: ({ id, text, resourceKey }: Omit<useSendActivityLogMessageMutationArguments, 'axios'>) => create({ axios, id, text, resourceKey }),
    onSuccess: () => {
      reset && reset({ text: '' });
      queryClient.invalidateQueries({ queryKey });
    },
  });
  useEffect(() => {
    if (mutation.isError) {
      setError &&
        setError('text', {
          type: 'server',
          message: (mutation.error as any)?.response?.data?.message,
        });
    }
  }, [mutation.isError, mutation.error, setError]);
  return mutation;
}
